
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/users/gift",
      function () {
        return require("private-next-pages/users/gift.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/users/gift"])
      });
    }
  